import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import * as api from "api"
import RatioElement from "common/ElementRatio"
import ResponsiveModelImage from "common/ResponsiveModelImage"
import { memo } from "react"
import Shared from "theme/shared"

const Styled = {
  Wrapper: styled.div`
    margin: 30px 0;
    overflow: hidden;
  `,
  Grid: styled.div`
    margin: 10px 27px;
    text-align: center;
  `,
  InnerGrid: styled.div`
    margin-top: 8px;
  `,
  Title: styled(Typography)`
    margin: 7px 27px;
    font-size: 18px;
    font-weight: 500;
    color: ${(p) => p.theme.colors.duskBlue};
  `,
  Description: styled(Typography)`
    margin-bottom: 10px;
    font-size: 14px;
    color: ${(p) => p.theme.colors.bluishGrey};
  `,
}

type VehicleTechnologiesMobileProps = { data: api.VehicleTechnolegy[] }

const VehicleTechnologiesMobile = ({
  data,
}: VehicleTechnologiesMobileProps) => {
  return (
    <Styled.Wrapper>
      <Shared.Header>ביצועים וטכנולוגיה</Shared.Header>
      <Shared.Divider />
      <Styled.Grid>
        {data.map((item, i) => (
          <Styled.InnerGrid key={i}>
            <RatioElement ratio={1 / 1}>
              <ResponsiveModelImage image={item.image} cover />
            </RatioElement>
            <Styled.Title> {item.name}</Styled.Title>
            <Styled.Description>{item.description}</Styled.Description>
          </Styled.InnerGrid>
        ))}
      </Styled.Grid>
    </Styled.Wrapper>
  )
}

export default memo(VehicleTechnologiesMobile)
